import React from "react";

const InvalidText = () => {
    return (
        <h6 id='errorMsg' style={{color: "red", fontSize: "14px"}}>Invalid Login Attempt!</h6>
    )
}

export default InvalidText
